module.exports = __webpack_public_path__ + "img/donante-susy-pasteleria.3a97117f.png";